// Centralized translations for the entire app (EN + AR)
// Source of truth for all bilingual content

export const translations = {
  en: {
    // Header
    nav: {
      menu: 'Menu',
      about: 'About',
      catering: 'Catering',
      contact: 'Contact',
      order: 'Order Now',
      call: 'Call Us'
    },
    // Hero
    hero: {
      headline: 'Authentic Mediterranean BBQ in Dallas',
      subheadline: 'Grilled over charcoal. Crafted with tradition.',
      orderNow: 'Order Now',
      viewMenu: 'View Menu'
    },
    // Signature Dishes
    dishes: {
      title: 'Signature Dishes',
      subtitle: 'Crafted with passion, grilled to perfection',
      items: [
        { name: 'Mix Grill Plate', description: 'A royal platter of lamb, chicken, and beef kebabs grilled over charcoal' },
        { name: 'Chicken Kebab', description: 'Tender marinated chicken skewers with aromatic Mediterranean spices' },
        { name: 'Iraqi Beef Shawarma', description: 'Slow-roasted beef with traditional Iraqi spices and tahini' },
        { name: 'Lamb Chops', description: 'Premium lamb chops charred to perfection with garlic and herbs' },
        { name: 'Chicken Shawarma Saj', description: 'Freshly carved shawarma served on saj bread' },
        { name: 'Falafel Mix Plate', description: 'Crispy falafel with hummus, baba ganoush, and fresh pita' }
      ]
    },
    // Experience
    experience: {
      title: 'More than food — a Mediterranean gathering experience',
      description: 'At Salam Grill, we bring the warmth of Mediterranean hospitality to every plate. Our charcoal grills blaze with traditions passed down through generations, creating flavors that transport you to the heart of the Mediterranean.',
      tradition: 'Family recipes preserved for generations',
      quality: 'Only the finest cuts and freshest ingredients'
    },
    // Why Choose Us
    whyUs: {
      title: 'Why Choose Salam Grill',
      items: [
        { id: 'authentic', title: 'Authentic Mediterranean Recipes', description: 'Traditional family recipes from the Mediterranean' },
        { id: 'fresh', title: 'Fresh Daily Ingredients', description: 'Hand-selected meats and produce every morning' },
        { id: 'charcoal', title: 'Charcoal Grilled Flavor', description: 'Authentic smoky taste from real charcoal fire' },
        { id: 'portions', title: 'Generous Portions', description: 'Feast-worthy servings that satisfy' }
      ]
    },
    // Menu
    menu: {
      title: 'Our Menu',
      subtitle: 'Explore our culinary journey',
      categories: ['BBQ', 'Appetizers', 'Salads', 'Drinks'],
      viewFull: 'View Full Menu'
    },
    // Build Your Grill
    buildGrill: {
      title: 'Custom Grill Platters',
      subtitle: 'We build your perfect platter — your choice of meats, sides, and more',
      meats: ['Lamb Kebab', 'Chicken Kebab', 'Beef Kebab', 'Mixed Grill', 'Lamb Chops', 'Chicken Shawarma'],
      sideOptions: ['Hummus', 'Baba Ganoush', 'Rice Pilaf', 'Fattoush Salad', 'Grilled Vegetables', 'Fresh Pita'],
      orderNow: 'Order Now',
      callToOrder: 'Call to Order'
    },
    // Testimonials
    testimonials: {
      title: 'What Our Guests Say',
      reviews: [
        { id: 'ahmed', name: 'Ahmed K.', text: 'Best Mediterranean BBQ in Dallas! The lamb chops are absolutely incredible. Reminds me of home.', rating: 5 },
        { id: 'sarah', name: 'Sarah M.', text: 'Authentic flavors and generous portions. The mixed grill is a must-try. Will definitely be back!', rating: 5 },
        { id: 'michael', name: 'Michael R.', text: 'Finally found a place that does real charcoal grilled kebabs. The taste is unmatched.', rating: 5 },
        { id: 'fatima', name: 'Fatima A.', text: 'The shawarma is the best I have had outside the Middle East. Fresh, flavorful, perfect!', rating: 5 }
      ]
    },
    // Location
    location: {
      title: 'Visit Us',
      address: '329 N Greenville Ave, Richardson, TX 75081',
      phone: '+1 972-238-9200',
      hours: 'Hours',
      delivery: 'Delivery Available',
      getDirections: 'Get Directions'
    },
    // CTA
    cta: {
      title: 'Ready to taste the real flavor?',
      subtitle: 'Experience authentic Mediterranean BBQ today',
      orderNow: 'Order Now',
      callUs: 'Call Us'
    },
    // Footer
    footer: {
      tagline: 'Authentic Mediterranean BBQ in Dallas',
      followUs: 'Follow Us'
    },
    // Gallery
    gallery: {
      title: 'Our Gallery',
      subtitle: 'A feast for the eyes'
    },
    // Social Media
    social: {
      title: 'Follow Us',
      subtitle: 'Stay connected for daily specials & updates',
      instagram: 'Follow on Instagram',
      facebook: 'Follow on Facebook',
      instagramHandle: '@salamgrilltx',
      facebookHandle: 'Salam Grill'
    }
  },
  ar: {
    // Header
    nav: {
      menu: 'القائمة',
      about: 'من نحن',
      contact: 'اتصل بنا',
      order: 'اطلب الآن',
      call: 'اتصل بنا'
    },
    // Hero
    hero: {
      headline: 'مشاوي متوسطية أصيلة في دالاس',
      subheadline: 'مشوي على الفحم... بطعم الأصالة',
      orderNow: 'اطلب الآن',
      viewMenu: 'عرض القائمة'
    },
    // Signature Dishes
    dishes: {
      title: 'الأطباق المميزة',
      subtitle: 'مصنوعة بشغف، مشوية بإتقان',
      items: [
        { name: 'طبق مشاوي مشكل', description: 'طبق ملكي من كباب الضأن والدجاج واللحم البقري المشوي على الفحم' },
        { name: 'كباب دجاج', description: 'أسياخ دجاج طرية متبلة بالتوابل المتوسطية العطرية' },
        { name: 'شاورما لحم عراقية', description: 'لحم بقري مشوي ببطء مع التوابل العراقية التقليدية والطحينة' },
        { name: 'ريش ضأن', description: 'ريش ضأن فاخرة مشوية بإتقان مع الثوم والأعشاب' },
        { name: 'شاورما دجاج ساج', description: 'شاورما طازجة تقدم على خبز الصاج' },
        { name: 'طبق فلافل مشكل', description: 'فلافل مقرمشة مع حمص وبابا غنوج وخبز طازج' }
      ]
    },
    // Experience
    experience: {
      title: 'أكثر من مجرد طعام — تجربة متوسطية أصيلة',
      description: 'في سلام جريل، نجلب لك دفء الضيافة المتوسطية في كل طبق. مشاوينا على الفحم تحمل تقاليد توارثناها عبر الأجيال، لنخلق نكهات تنقلك إلى قلب البحر المتوسط.',
      tradition: 'وصفات عائلية محفوظة عبر الأجيال',
      quality: 'أجود أنواع اللحوم والمكونات الطازجة فقط'
    },
    // Why Choose Us
    whyUs: {
      title: 'لماذا سلام جريل',
      items: [
        { id: 'authentic', title: 'وصفات متوسطية أصيلة', description: 'وصفات عائلية تقليدية من البحر المتوسط' },
        { id: 'fresh', title: 'مكونات طازجة يومياً', description: 'لحوم ومنتجات مختارة بعناية كل صباح' },
        { id: 'charcoal', title: 'نكهة الفحم الأصيلة', description: 'طعم مدخن أصيل من نار الفحم الحقيقي' },
        { id: 'portions', title: 'حصص سخية', description: 'وجبات كبيرة ترضي الجميع' }
      ]
    },
    // Menu
    menu: {
      title: 'قائمة الطعام',
      subtitle: 'استكشف رحلتنا الطهوية',
      categories: ['مشاوي', 'مقبلات', 'سلطات', 'مشروبات'],
      viewFull: 'عرض القائمة الكاملة'
    },
    // Build Your Grill
    buildGrill: {
      title: 'صمم طبق مشاويك',
      subtitle: 'خصص طبقك المثالي',
      meatType: 'اختر نوع اللحم',
      quantity: 'اختر الكمية',
      sides: 'أضف الأطباق الجانبية',
      meats: ['كباب ضأن', 'كباب دجاج', 'كباب لحم', 'مشاوي مشكلة', 'ريش ضأن', 'شاورما دجاج'],
      sideOptions: ['حمص', 'بابا غنوج', 'أرز بيلاف', 'سلطة فتوش', 'خضار مشوية', 'خبز طازج'],
      total: 'المجموع التقديري',
      orderNow: 'اطلب عبر دوردش',
      callToOrder: 'اتصل للطلب'
    },
    // Testimonials
    testimonials: {
      title: 'ماذا يقول ضيوفنا',
      reviews: [
        { id: 'ahmed', name: 'أحمد ك.', text: 'أفضل مشاوي متوسطية في دالاس! ريش الضأن لا تصدق. تذكرني بالوطن.', rating: 5 },
        { id: 'sarah', name: 'سارة م.', text: 'نكهات أصيلة وحصص سخية. المشاوي المشكلة يجب تجربتها. سأعود بالتأكيد!', rating: 5 },
        { id: 'michael', name: 'مايكل ر.', text: 'أخيراً وجدت مكاناً يقدم كباب مشوي على الفحم الحقيقي. الطعم لا مثيل له.', rating: 5 },
        { id: 'fatima', name: 'فاطمة أ.', text: 'الشاورما الأفضل التي تذوقتها خارج الشرق الأوسط. طازجة، لذيذة، مثالية!', rating: 5 }
      ]
    },
    // Location
    location: {
      title: 'زورونا',
      address: '329 N Greenville Ave, Richardson, TX 75081',
      phone: '+1 972-238-9200',
      hours: 'ساعات العمل',
      delivery: 'التوصيل متاح',
      getDirections: 'احصل على الاتجاهات'
    },
    // CTA
    cta: {
      title: 'جاهز لتجربة الطعم الحقيقي؟',
      subtitle: 'اختبر المشاوي المتوسطية الأصيلة اليوم',
      orderNow: 'اطلب الآن',
      callUs: 'اتصل بنا'
    },
    // Footer
    footer: {
      tagline: 'مشاوي متوسطية أصيلة في دالاس',
      followUs: 'تابعنا'
    },
    // Gallery
    gallery: {
      title: 'معرض الصور',
      subtitle: 'متعة للعيون'
    },
    // Social Media
    social: {
      title: 'تابعونا',
      subtitle: 'ابقوا على تواصل للعروض اليومية والتحديثات',
      instagram: 'تابعنا على انستغرام',
      facebook: 'تابعنا على فيسبوك',
      instagramHandle: '@salamgrilltx',
      facebookHandle: 'Salam Grill'
    }
  }
};
